'use strict';

angular.module('riskModule')

.controller('SelectGovernanceProcessesForExportExcelController', ['$scope', 'grcGovernanceProcessService', function ($scope, grcGovernanceProcessService) {

    $scope.exportExcelCtxt = {};

    grcGovernanceProcessService.getRiskSelfAssessments()
        .then(function (govProcesses) {
            $scope.govProcesses = govProcesses;

            $scope.exportExcelCtxt.currentProcess = $scope.govProcesses[0];
            $scope.exportExcelCtxt.previousProcess = $scope.govProcesses[1];
        });
}]);